import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const Index = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [termData, setTermsData] = useState(null);

  useEffect(() => {
    axios
      .get(`${baseURL}/about/fetchTerms`)
      .then((response) => {
        setTermsData(response?.data?.data[0]?.content);
      })
      .catch((error) => {
        console.error("Error fetching about us data:", error);
      });
  }, []);

  return (
    <div className="container">
      <h2 className="font accentColor text-center mt-5">
        Terms and Conditions
      </h2>
      <div className="ck_editor">
        <div
          className="embed-responsive embed-responsive-16by9 mt-3"
          dangerouslySetInnerHTML={{ __html: termData }}
        />
      </div>
    </div>
  );
};

export default Index;
